import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import { getOneCompanyHolidayListQueryOptions } from "@/config/queries/query-options";
import { Spinner } from "@/components/ui/spinner/spinner";
import { EditCompanyHolidayForm } from "./_components/edit-company-holiday-form";

const EditCompanyHolidayListPage = () => {
  const { companyHolidayId } = useParams<{ companyHolidayId: string }>();
  const adminKey = Cookies.get("key") as string;

  const { data, isPending } = useQuery(
    getOneCompanyHolidayListQueryOptions(adminKey, companyHolidayId || "")
  );

  if (isPending) {
    return (
      <div className="p-5 h-20 flex items-center justify-center">
        <Spinner size="small">
          <p>Loading...</p>
        </Spinner>
      </div>
    );
  }

  if (!data?.foundList) {
    return (
      <div className="p-5">
        <div className="border h-20 flex items-center justify-center">
          Company holiday list not found.
        </div>
      </div>
    );
  }

  return (
    <div className="p-5 max-h-[calc(100%-56px)] overflow-y-auto">
      <EditCompanyHolidayForm holidayList={data.foundList} />
    </div>
  );
};

export default EditCompanyHolidayListPage;
